<!--
 * @Descripttion: 首页组件
 * @Author: congz
 * @Date: 2020-06-04 11:22:40
 * @LastEditors: congz
 * @LastEditTime: 2020-08-12 21:20:08
--> 

<template>
  <div class="home" id="home" name="home">
    <!-- Hero Section -->
    <div class="hero">
      <div class="hero-banner" :style="{ backgroundImage: `url(${heroImage})` }">
        <div class="hero-overlay">
          <div class="hero-title">Embrace Elegance with Our Exquisite Indian Fashion Collection</div>
          <div class="hero-desc">
            Discover stunning sarees, lehengas, and ethnic wear crafted for the modern Indian woman. Shop now to adorn yourself in tradition with a contemporary twist.
          </div>
          <router-link class="hero-btn" to="/goods">Shop Now</router-link>
        </div>
      </div>
    </div>

    <!-- Category Products Section -->
    <div class="main-box">
      <div class="main">
        <div class="section-header">
          <h2>New Arrivals</h2>
          <p>Fresh styles just for you</p>
        </div>
        <div class="category-products">
          <ProductGrid :list="homeProducts" :isMore="false"></ProductGrid>
        </div>

        <!-- Why Shop With Us -->
        <div class="why-section">
          <div class="why-item">
            <div class="why-icon">🚚</div>
            <h3>Free Shipping</h3>
            <p>On orders above ₹999</p>
          </div>
          <div class="why-item">
            <div class="why-icon">✨</div>
            <h3>Premium Quality</h3>
            <p>100% handcrafted products</p>
          </div>
          <div class="why-item">
            <div class="why-icon">🔄</div>
            <h3>Easy Returns</h3>
            <p>7-day hassle-free returns</p>
          </div>
          <div class="why-item">
            <div class="why-icon">💳</div>
            <h3>Secure Payment</h3>
            <p>Multiple payment options</p>
          </div>
        </div>

        <!-- Discover Section -->
        <div class="home-section">
          <div class="home-section-header">
            <div>
              <h2>Curated Ethnic Collections</h2>
              <p>Handpicked designs for every occasion</p>
            </div>
            <div class="section-tabs">
              <span class="tab-item" :class="{active: discoverActive==='SHORTKURTIS'}" @click="discoverActive='SHORTKURTIS'">SILK SAREES</span>
              <span class="tab-item" :class="{active: discoverActive==='SUNGLASSES'}" @click="discoverActive='SUNGLASSES'">ANARKALI</span>
              <span class="tab-item" :class="{active: discoverActive==='HOT'}" @click="discoverActive='HOT'">LEHENGA</span>
            </div>
          </div>
          <ProductGrid :list="discoverProducts" :isMore="false"></ProductGrid>
          <router-link class="section-cta" to="/goods">See More</router-link>
        </div>

        <!-- Full Width Promo Banner -->
        <div class="promo-full-banner">
          <div class="promo-content">
            <span class="promo-tag">Limited Time Offer</span>
            <h2>FESTIVE COLLECTION 2026</h2>
            <p>Up to 40% Off on Designer Sarees & Lehengas</p>
            <router-link class="promo-btn" to="/goods">Shop Now</router-link>
          </div>
          <div class="promo-image">
            <img src="https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop4/769013402/02a91d6FlowerVely_Lakhanvi_Light-Pink_1.avif" alt="Festive" />
          </div>
        </div>

        <!-- Split Banners -->
        <div class="split-banners-grid">
          <div class="split-banner">
            <div class="split-content">
              <div class="split-title">Bridal Collection</div>
              <div class="split-desc">
                Exquisite bridal lehengas and sarees for your special day
              </div>
              <router-link class="section-cta" to="/goods">Explore Now</router-link>
            </div>
            <div class="split-image">
               <img src="https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop4/769013468/e40f2e1KANVI6004_RB_2.avif" alt="Bridal" />
            </div>
          </div>
          <div class="split-banner">
            <div class="split-content">
              <div class="split-title">Summer Essentials</div>
              <div class="split-desc">
                Light, breathable fabrics perfect for everyday elegance
              </div>
              <router-link class="section-cta" to="/goods">Explore Now</router-link>
            </div>
            <div class="split-image">
               <img src="https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop4/769013639/1a9840a46099_1.avif" alt="Summer" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as carouselsAPI from '@/api/carousels/'
import * as productsAPI from '@/api/products/'
import * as rankingAPI from '@/api/ranking/'
import * as categoryAPI from '@/api/categories/'
import ProductGrid from '@/components/ProductGrid'

export default {
  components: { ProductGrid },
  data() {
    return {
      carousels: [], // 轮播图数据
      phonesList: [], // 手机商品列表
      televisionsList: [], // 小米电视商品列表
      applianceList: [], // 家电商品列表
      applianceHotList: [], //热门家电商品列表
      accessoryList: [], //配件商品列表
      accessoryHotList: [], //热门配件商品列表
      phoneShellsList: [], // 保护套商品列表
      chargersList: [], //充电器商品列表
      applianceActive: 1, // 家电当前选中的商品分类
      accessoryActive: 1, // 配件当前选中的商品分类
      discoverActive: 'SHORTKURTIS', // Discover section active tab
      shortKurtisList: [],
      sunglassesList: [],
      start: 0,
      limit: 7,
      homeCategories: [],
      activeCategoryId: 0,
      homeProducts: [],
      homeStart: 0,
      homeLimit: 8
    }
  },
  computed: {
    heroImage() {
      if (this.carousels && this.carousels.length) {
        return this.carousels[0].img_path
      }
      return 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop4/769006299/81-OTIjtaXL._SY741_-430x664.jpg'
    },
    discoverProducts() {
      if (this.discoverActive === 'SHORTKURTIS') return this.shortKurtisList
      if (this.discoverActive === 'SUNGLASSES') return this.sunglassesList
      return this.phonesList // Default HOT
    }
  },
  watch: {
    // 家电当前选中的商品分类，响应不同的商品数据
    applianceActive: function(val) {
      // 页面初始化的时候把applianceHotList(热门家电商品列表)直接赋值给applianceList(家电商品列表)
      // 所以在切换商品列表时判断applianceHotList是否为空,为空则是第一次切换,把applianceList赋值给applianceHotList
      if (this.applianceHotList == '') {
        this.applianceHotList = this.televisionsList
      }
      if (val == 1) {
        // 1为热门商品
        this.applianceList = this.applianceHotList
        return
      }
      if (val == 2) {
        // 2为电视商品
        this.applianceList = this.televisionsList
        return
      }
    },
    accessoryActive: function(val) {
      // 页面初始化的时候把accessoryHotList(热门配件商品列表)直接赋值给accessoryList(配件商品列表)
      // 所以在切换商品列表时判断accessoryHotList是否为空,为空则是第一次切换,把accessoryList赋值给accessoryHotList
      if (this.accessoryHotList == '') {
        this.accessoryHotList = this.chargersList
      }
      if (val == 3) {
        // 1为热门商品
        this.accessoryList = this.accessoryHotList
        return
      }
      if (val == 2) {
        // 2为保护套商品
        this.accessoryList = this.phoneShellsList
        return
      }
      if (val == 1) {
        //3 为充电器商品
        this.accessoryList = this.chargersList
        return
      }
    }
  },
  activated() {
    // 获取首页数据
    this.load()
  },
  methods: {
    load() {
      carouselsAPI
        .listCarousels()
        .then(res => {
          if (res.status == 200) {
            this.carousels = res.data
          } else {
            this.notifyError('Failed', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })
      // 首页类目：取导航“Shop Now”同源分类
      categoryAPI
        .listCategories()
        .then(res => {
          if (res.status === 200) {
            const list = Array.isArray(res.data) ? res.data : []
            this.homeCategories = [{ category_id: 0, category_name: 'All' }, ...list]
            this.activeCategoryId = 0
            this.fetchHomeProducts(0)
            
            // Find categories for Discover section
            const shortKurtisCat = list.find(c => c.category_name.toLowerCase() === 'shortkurtis')
            if (shortKurtisCat) this.getProduct(shortKurtisCat.category_id, 'shortKurtisList')
            
            const sunglassesCat = list.find(c => c.category_name.toLowerCase() === 'sunglasses')
            if (sunglassesCat) this.getProduct(sunglassesCat.category_id, 'sunglassesList')
          } else {
            this.notifyError('Failed to obtain classification', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed to obtain classification', err)
        })
      //获取热门家电
      rankingAPI
        .listElecRanking()
        .then(res => {
          if (res.status === 200) {
            this.applianceHotList = res.data
            this.applianceList = res.data
          } else {
            this.notifyError('Failed')
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })
      //获取热门配件
      rankingAPI
        .listAcceRanking()
        .then(res => {
          if (res.status === 200) {
            this.accessoryHotList = res.data
            this.accessoryList = res.data
          } else {
            this.notifyError('Failed')
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })
      //获取手机列表
      this.getProduct(21, 'chargersList')

      this.getProduct(27, 'phonesList')
      //获取电视列表
      this.getProduct(23, 'televisionsList')
      //获取保护套列表
      this.getProduct(5, 'phoneShellsList')
      //获取充电器列表
    },
    // Find categories for Discover section
    findDiscoverCategories(list) {
      const shortKurtisCat = list.find(c => c.category_name.toLowerCase() === 'shortkurtis')
      if (shortKurtisCat) this.getProduct(shortKurtisCat.category_id, 'shortKurtisList')
      
      const sunglassesCat = list.find(c => c.category_name.toLowerCase() === 'sunglasses')
      if (sunglassesCat) this.getProduct(sunglassesCat.category_id, 'sunglassesList')
    },
    selectCategory(id) {
      if (this.activeCategoryId === id) return
      this.activeCategoryId = id
      this.homeStart = 0
      this.fetchHomeProducts(id)
    },
    fetchHomeProducts(categoryId) {
      productsAPI
        .listProducts(categoryId, this.homeStart, this.homeLimit)
        .then(res => {
          if (res.status === 200) {
            this.homeProducts = this.shuffle(Array.isArray(res.data.items) ? res.data.items : [])
          } else {
            this.notifyError('Failed', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })
    },
    // 获取家电模块子组件传过来的数据
    getChildMsg(val) {
      this.applianceActive = val
    },
    // 获取配件模块子组件传过来的数据
    getChildMsg2(val) {
      this.accessoryActive = val
    },
    // 获取各类商品数据方法封装
    getProduct(categoryID, val) {
      productsAPI
        .listProducts(categoryID, this.start, this.limit)
        .then(res => {
          if (res.status === 200) {
            this[val] = this.shuffle(res.data.items || [])
          } else {
            this.notifyError('Failed', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })
    },
    // Fisher-Yates shuffle
    shuffle(array) {
      const arr = [...array]
      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        ;[arr[i], arr[j]] = [arr[j], arr[i]]
      }
      return arr
    }
  },
  beforeRouteEnter(to, from, next) {
    // 添加背景色
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#FDF8F5')
    next()
  },
  beforeRouteLeave(to, from, next) {
    // 去除背景色
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#FDF8F5')
    next()
  }
}
</script>
<style scoped>
@import '../assets/css/index.css';
</style>
